import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import DefaultLayout from '@/views/layout/default.vue'
import Login from '@/views/login/login.vue'
import ResetPassword from '@/views/reset_password/reset_password.vue'
import Dashboard from '@/views/dashboard/index.vue'
import Register from '@/views/register/register.vue'
import Profile from '@/views/profile/profile.vue'
import Withdrawal from '@/views/withdrawal/withdrawal.vue'
import RegisterComplete from '@/views/register/complete/complete.vue'
import TemporaryComplete from '@/views/register/temporary/complete.vue'
import CompleteReset from '@/views/reset_password/complete/complete.vue'
import InvalidReset from '@/views/reset_password/invalid/invalid.vue'
import PaymentComplete from '@/views/payment/complete/complete.vue'
import PaymentCheckPaypay from '@/views/payment/check/paypay.vue'
import WithdrawalComplete from '@/views/withdrawal/complete/complete.vue'
import ConfirmEmail from '@/views/confirm_email/confirm_email.vue'
import ReconfirmEmail from '@/views/reconfirm_email/index.vue'
import NewPassword from '@/views/reset_password/new_password/new_password.vue'
import TemporaryReset from '@/views/reset_password/reset_message/reset_message.vue'
import BuyPlan from '@/views/buy_plan/buy_plan.vue'
import Payment from '@/views/buy_plan/payment/payment.vue'
import Contact from '@/views/contact/index.vue'
import ContactComplete from '@/views/contact/complete/complete.vue'
import CheckQuestion from '@/views/question/check.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/reset_password',
      name: 'reset_password',
      component: ResetPassword,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/confirm_email/:token',
      name: 'confirm_email',
      component: ConfirmEmail,
      meta: {
        title: 'メール確認',
        auth: false
      }
    },
    {
      path: '/reconfirm_email/:token',
      name: 'reconfirm_email',
      component: ReconfirmEmail,
      meta: {
        title: 'メール確認',
        auth: false
      }
    },
    {
      path: '/',
      component: DefaultLayout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          component: Dashboard,
          meta: {
            title: 'ホーム',
            auth: true,
            menu: [
              {
                label: 'ユーザー情報',
                handler: (): any => router.push({ path: '/profile' })
              },
              {
                label: 'サポート（QA/お問い合わせ）',
                handler: (): any => openContactTab()
              },
              {
                label: 'PolariStationについて',
                handler: (): any => openNewTab()
              }
            ]
          }
        },
        {
          path: '/profile',
          component: Profile,
          meta: {
            title: 'ユーザー情報',
            auth: true
          }
        },
        {
          path: 'contents',
          component: () => import('@/views/contents/content-list/index.vue'),
          meta: {
            title: 'コンテンツ',
            auth: true
          }
        },
        {
          path: 'contents/:id',
          component: () => import('@/views/contents/show.vue'),
          meta: {
            title: 'コンテンツ',
            auth: true
          }
        },
        {
          path: 'units/:id',
          component: () => import('@/views/units/show.vue'),
          meta: {
            title: 'ユニット',
            auth: true
          }
        },
        {
          path: 'units/:id/results',
          component: () => import('@/views/results/index.vue'),
          meta: {
            title: '履歴',
            auth: true
          }
        },
        {
          path: 'units/:id/results/:implId',
          component: () => import('@/views/results/show.vue'),
          meta: {
            title: '結果確認',
            auth: true
          }
        },
        {
          path: '/withdrawal',
          name: 'withdrawal',
          component: Withdrawal,
          meta: {
            title: 'ログイン',
            auth: true
          }
        },
        {
          path: 'contents/:id/buy_plan',
          name: 'buy_plan',
          component: BuyPlan,
          meta: {
            title: '購入プラン',
            auth: true
          }
        },
        {
          path: 'contents/:id/buy_plan/:plan_id',
          name: 'payment',
          component: Payment,
          meta: {
            title: '購入プラン',
            auth: true
          }
        },
        {
          path: '/contact',
          name: 'contact',
          component: Contact,
          meta: {
            title: 'お問い合わせ',
            auth: true
          }
        },
        {
          path: '/contact/complete',
          name: 'contact-complete',
          component: ContactComplete,
          meta: {
            title: 'ログイン',
            auth: true
          }
        },
        {
          path: 'questions/check',
          component: CheckQuestion,
          meta: {
            title: '設問チェック',
            auth: true
          }
        }
      ]
    },
    {
      path: '/withdrawal/complete',
      name: 'withdrawal_complete',
      component: WithdrawalComplete,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/reset_password/new_password/:id',
      name: 'NewPassword',
      component: NewPassword,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/register/complete',
      name: 'register_complete',
      component: RegisterComplete,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/register/temporary/complete',
      name: 'temporary_complete',
      component: TemporaryComplete,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/reset_password/invalid',
      name: 'invalid_reset',
      component: InvalidReset,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/reset_password/complete',
      name: 'reset_complete',
      component: CompleteReset,
      meta: {
        title: 'ログイン',
        auth: false
      }
    },
    {
      path: '/reset_password/temporary',
      name: 'reset_temporary',
      component: TemporaryReset,
      meta: {
        title: 'リセット',
        auth: false
      }
    },
    {
      path: '/payment/:id/complete',
      name: 'payment_complete',
      component: PaymentComplete,
      meta: {
        title: 'ログイン',
        auth: true
      }
    },
    {
      path: '/payment/:id/check/paypay',
      name: 'payment_check_paypay',
      component: PaymentCheckPaypay,
      meta: {
        title: '決済確認中',
        auth: true
      }
    },
    {
      path: '/corp_user_confirm_email/:token',
      component: () =>
        import('@/views/register/user-password/new_password.vue'),
      meta: {
        title: '管理者ユーザ登録',
        auth: false
      }
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  store.dispatch('setTitle', to.meta.title || '')

  if (!navigator.onLine) {
    Vue.notify({
      text:
        'エラーが発生しました。ネットワーク状態をご確認いただき、再度お試しください。改善しない場合はお手数ですがサポートまでご連絡ください。',
      type: 'error'
    })
    return
  }

  if (to.meta.menu) {
    store.dispatch('setMenu', to.meta.menu)
  } else {
    store.dispatch('setMenuDefault')
  }

  if (to.meta.auth) {
    if (!store.state.token) {
      next({ path: '/login' })
      return
    }

    store.dispatch('clearMessage')
    await store
      .dispatch('getSelfInfo')
      .then(() => next())
      .catch(e => {
        Vue.notify({
          text:
            '別の端末からログインされたためログアウトしました。お手数ですが再度ログインしてご使用ください。',
          type: 'error'
        })
        return
      })
  } else {
    if (!localStorage.getItem('token') || to.name === 'reconfirm_email') next()
    else next('/')
  }
})

function openNewTab() {
  window.open('https://polaristation.com/', '_blank')
}

function openContactTab() {
  window.open('/contact', '_blank')
}

export default router
